import * as t from  './actionTypes';
import * as api from './api';

export function loadLocations() {

  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.getLocations((success, locations, error) => {
      if (success) {
        dispatch({ type: t.LOCATION_LOAD_SUCCESS, locations: locations });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });

      }
    });
  }
}

export function createNewLocation(data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.createNewLocation(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.LOCATION_CREATE_SUCCESS, location: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

export function editLocation(id, data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.editLocation(id, data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.LOCATION_EDIT_SUCCESS, id: id, location: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

export function archiveLocationOffer(id, data, CB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.archiveLocationOffer(id, data, function(success, data, error) {
      dispatch({ type: t.UNSET_BUSY });
      CB();
    })
  }
}

export function deleteLocation(id, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.deleteLocation(id, function(success, error) {
      if (success) {
        dispatch({ type: t.LOCATION_DELETE_SUCCESS, id: id });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}
